import { render, staticRenderFns } from "./type-input.vue?vue&type=template&id=1d842b66&scoped=true&"
import script from "./type-input.vue?vue&type=script&lang=js&"
export * from "./type-input.vue?vue&type=script&lang=js&"
import style0 from "./type-input.vue?vue&type=style&index=0&id=1d842b66&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d842b66",
  null
  
)

export default component.exports